import * as Yup from 'yup';
import { Select, TextField, FieldData } from 'vopay';
import { useTranslation } from 'react-i18next';
import { DigitalWalletRequest } from './DigitalWalletForm';
import AccountType from '@/components/Connect/Email/Form/AccountType/AccountType';

export function useDigitalWalletFormRows(
  eLinxHasName: boolean,
  digitalWalletMethod: 'paypal' | 'venmo',
): FieldData<DigitalWalletRequest>[] {
  const { t } = useTranslation('translations', { keyPrefix: 'PaymentMethodForm' });

  const PaymentOptions = [
    { label: t('phoneNumber'), value: 'PHONE' },
    { label: t('email'), value: 'EMAIL' },
  ];

  return [
    {
      label: () => t('accountType'),
      fieldName: 'AccountType',
      getInputState: () => 'required',
      showField: () => !eLinxHasName && digitalWalletMethod === 'paypal',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<'personal' | 'business'>({});
        return <AccountType {...fieldData} />;
      },
    },
    {
      label: () => t('firstName'),
      fieldName: 'FirstName',
      getInputState: () => 'required',
      showField: (values) => !eLinxHasName && values.AccountType === 'personal',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="outlineShadow" preset="text" {...fieldData} />;
      },
      validate: () => Yup.string().required(t('valueRequired') || 'This value is required'),
    },
    {
      label: () => t('lastName'),
      fieldName: 'LastName',
      getInputState: () => 'required',
      showField: (values) => !eLinxHasName && values.AccountType === 'personal',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="outlineShadow" preset="text" {...fieldData} />;
      },
      validate: () => Yup.string().required(t('valueRequired') || 'This value is required'),
    },
    {
      label: () => t('companyName'),
      fieldName: 'CompanyName',
      getInputState: () => 'required',
      showField: (values) => !eLinxHasName && values.AccountType === 'business',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="outlineShadow" preset="text" {...fieldData} />;
      },
      validate: () => Yup.string().required(t('valueRequired') || 'This value is required'),
    },
    {
      label: () => t('paymentMethod'),
      fieldName: 'PaymentMethod',
      getInputState: () => 'required',
      showField: () => true,
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <Select version="2" placeholder="" options={PaymentOptions} {...fieldData} />;
      },
      validate: () => Yup.string().required(t('valueRequired') || 'This value is required'),
    },
    {
      label: () => t('phoneNumber'),
      fieldName: 'PhoneNumber',
      getInputState: () => 'required',
      showField: (values: DigitalWalletRequest) => values.PaymentMethod === 'PHONE',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="outlineShadow" preset="text" placeholder={t('enter') || ''} {...fieldData} />;
      },
      validate: () => Yup.string().required(t('valueRequired') || 'This value is required'),
    },
    {
      label: () => t('emailAddress'),
      fieldName: 'EmailAddress',
      getInputState: () => 'required',
      showField: (values: DigitalWalletRequest) => values.PaymentMethod === 'EMAIL',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});
        return <TextField variant="outlineShadow" preset="text" placeholder={t('enter') || ''} {...fieldData} />;
      },
      validate: () => Yup.string().required(t('valueRequired') || 'This value is required'),
    },
  ];
}
